export enum API_ROUTES {

    /**
     * EXT
     */
    GET_PROJECT_BY_COUNTRY= "0/public/config/retrive-projects-info/:countryCode",
    VALIDATE_VAT= ":projectLogicId/private/piva/validate",
    VERIFY_FILES= ":projectLogicId/private/invoices/verify",
    POINTSCAP_CHECK_USER= ":projectLogicId/private/pointscap/check/user",
    GET_INVOICES = ":projectLogicId/:accessType/invoices",
    GET_INVOICE = ":projectLogicId/:accessType/invoices/:invoiceId",

    /**
     * CMS
     */
    GET_TRANSLATIONS= ":projectLogicId/:accessType/translations/:lang",
    GET_CMS_WEBAPP = ":projectLogicId/:accessType/cms/webApp",
    GET_CMS_USER = ":projectLogicId/:accessType/cms/consumer",
    GET_CMS_CONTEST = ":projectLogicId/:accessType/cms/contest",
    GET_CMS_EVENT = ":projectLogicId/:accessType/cms/event",
    GET_CMS_REWARD = ":projectLogicId/:accessType/cms/reward",

    /**
     * Catalog
     */
    GET_CATALOG = ":projectLogicId/private/initiatives/:catalogInitiativeId/products",
    GET_PRODUCT = ":projectLogicId/private/initiatives/:catalogInitiativeId/products/:productId",
    GET_CART = ":projectLogicId/private/initiatives/:catalogInitiativeId/baskets",
    ADD_TO_CART = ":projectLogicId/private/initiatives/:catalogInitiativeId/baskets",
    REMOVE_CART_ITEM = ":projectLogicId/private/initiatives/:catalogInitiativeId/baskets/products/:catalogGroupProductLogicId",
    CONFIRM_CART = ":projectLogicId/private/initiatives/:catalogInitiativeId/baskets/checkout",

    /**
     * Redemption
     */
    GET_REDEMPTIONS = ":projectLogicId/:accessType/redemptions",
    GET_REDEMPTION_DETAILS = ":projectLogicId/private/redemptions/:redemptionLogicId",
    POST_REDEMPTION_ADDRESS = ":projectLogicId/private/reward/redemptions/:redemptionLogicId/update-address",
    POST_REDEMPTION_APPROVAL = ":projectLogicId/private/reward/redemptions/:redemptionLogicId/approve",

    /**
     * Notification
     */

    GET_NOTIFICATIONS = ":projectLogicId/:accessType/notifications/:userExternalId",
    POST_NOTIFICATIONS = ":projectLogicId/:accessType/notifications",

    /**
     * Transaction
     */
    GET_TRANSACTIONS = ":projectLogicId/private/transaction",
    /**
     * Wallet
     */
    GET_BALANCES = ":projectLogicId/:accessType/wallets/points",

    /**
     * Event
     */
    GET_EVENT_LIST = ":projectLogicId/:accessType/events",
    GET_EVENT_GROUP_LIST = ":projectLogicId/:accessType/events/groups",
    GET_EVENT_DETAILS = ":projectLogicId/:accessType/events/:eventId",
    SEND_EVENT = ":projectLogicId/:accessType/events/:eventId/send",

    /**
     * User (consumer)
     */
    POST_SSO = ":projectLogicId/private/v4/sso",
    GET_SSO_FINALIZATION_FORM = ":projectLogicId/private/v4/consumers/forms/finalization/sso",
    POST_SSO_FINALIZATION = ":projectLogicId/private/v4/sso", // PATCH

    GET_LOGIN_FORM = ":projectLogicId/public/v4/consumers/forms/login",
    POST_LOGIN = ":projectLogicId/public/v4/login",
    GET_WEB_FINALIZATION_FORM = ":projectLogicId/private/v4/consumers/forms/finalization/web",
    POST_WEB_FINALIZATION = ":projectLogicId/private/v4/finalization", // PATCH

    GET_PROFILE_FORM = ":projectLogicId/private/v4/consumers/forms/profile",

    GET_REGISTRATION_FORM = ":projectLogicId/public/v4/consumers/forms/registration",
    VERIFY_INVITATION_CODE = ":projectLogicId/public/v2/invitationcodes/verify",
    POST_REGISTRATION = ":projectLogicId/public/v4/registration",
    CONFIRM_ACCOUNT = ":projectLogicId/public/v4/registration", // PUT

    GET_PASSWORD_RECOVER_FORM = ":projectLogicId/public/v4/consumers/forms/password-reset/username",
    POST_PASSWORD_RECOVER = ":projectLogicId/public/v4/password-reset",

    GET_PASSWORD_RESET_FORM = ":projectLogicId/public/v4/consumers/forms/password-reset/password",
    POST_PASSWORD_RESET = ":projectLogicId/public/v4/password-reset",

    POST_RESEND_ACTIVATION_LINK = ":projectLogicId/public/activation",

    GET_USER = ":projectLogicId/private/v4/consumers",
    PATCH_USER = ":projectLogicId/private/v4/consumers",
    LOGOUT = ":projectLogicId/private/logout",
    REFRESH_TOKEN = ":projectLogicId/public/refresh",

    GET_USER_INFO = ":projectLogicId/private/customers/info",

    PUT_USER_EVALUATE = ":projectLogicId/private/customers/evaluateStatus",

    GET_AGINGS = "api/aging",

    POST_USER_UNSUBSCRIBE = ":projectLogicId/private/customers/unsubscribe",
    POST_USER_UNSUBSCRIBE_UNDO = ":projectLogicId/private/customers/unsubscribe/undo",

    POST_SELECT_SUPPLY = ":projectLogicId/private/supplies",

    GET_ISSUE_LIST = ":projectLogicId/public/issuetypes",
    POST_TICKET = ":projectLogicId/:accessType/back-office/consumer/ticket",

    /**
     * ContentIo
     */
    UPLOAD_FILE = ":projectLogicId/private/upload",
    ZENDESK_UPLOAD_FILE = ":projectLogicId/private/zendesk/upload",
    DOWNLOAD_FILE = ":projectLogicId/private/download",
}

type API_ROUTES_PATHS = Record<API_ROUTES, string>;
type API_ROUTES_PATHS_KEYS = keyof API_ROUTES_PATHS;

export interface ApiRoute {
    path: API_ROUTES_PATHS_KEYS;
    module?: API_MODULES;
    solution?: API_SOLUTIONS;
    baseURL?: string;
    params?: Record<string, string|number>;
}

export enum API_MODULES {
    CONFIGURATION = "core-configuration",
    SOLUTION = "solution-mz",
    CORE_CONTENT_IO = 'core-contentio',

    FORMAT_EVENT = "format-event",
    CORE_EVENT = "core-event",

    FORMAT_CONTEST = "format-contest",
    CORE_CONTEST = "core-contest",

    FORMAT_REWARD = "format-reward",
    CORE_REWARD = "core-reward",

    FORMAT_USER = "format-user",
    CORE_USER = "core-user",

    FORMAT_WALLET = "format-wallet'",
    CORE_WALLET = "core-wallet",

    COLLECTION = "format-digital-collection",

    SOLUTION_CMR_BACKOFFICE = "solution-cmr-backoffice",

    ZENDESK = "zendesk",

    EXT = "ext-gewiss",

}

export enum API_SOLUTIONS {
    MZ = "mz"
}
